import React, { Component } from 'react';
import { Button, Card, Label, Input, FormGroup, CardBody, CardGroup, Col, Container, Alert, InputGroup, InputGroupAddon, Row} from 'reactstrap';
import { ValidationForm, TextInput} from "react-bootstrap4-form-validation";
import _ from "lodash";
import {Redirect, Link} from 'react-router-dom';
import Http from '../../../services/Http';
import apiPath from '../../../constants/apiPath';
import { adminLogin } from "../../../actions/index";
import { connect } from "react-redux";
import IconButton from "@material-ui/core/IconButton";
import InputLabel from "@material-ui/core/InputLabel";
import Visibility from "@material-ui/icons/Visibility";
import InputAdornment from "@material-ui/core/InputAdornment";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputTxt from "@material-ui/core/Input";
import $ from 'jquery';

import logo from '../../../assets/img/brand/logo.png';

const mapStateToProps = state => {
  return { admin: state.admin };
};

const mapDispatchToProps = dispatch => {
  return {
    adminLogin: admin => dispatch(adminLogin(admin))
  };
};

/*
const handleClickShowPassword = () => {
  setValues({ ...values, showPassword: !values.showPassword });
};

const handleMouseDownPassword = (event) => {
  event.preventDefault();
};

const handlePasswordChange = (prop) => (event) => {
  setValues({ ...values, [prop]: event.target.value });
};*/

class Login extends Component {
  constructor(props){
    super(props);
    this.formRef = React.createRef();
    this.state = {
      loading: false,
      immediate:true,
      setFocusOnError:true,
      clearInputOnReset:false,
      account_type: 'superadmin',
      isRememberMe: (!_.isEmpty(localStorage.getItem('username')) && !_.isEmpty(localStorage.getItem('userPassword'))) ? true: false,
      username: localStorage.getItem('username') || '',
      password: localStorage.getItem('userPassword') || '',
      showPassword: false,
    };
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: (e.target.name === 'isRememberMe') ? e.target.checked : e.target.value
    });
    if((e.target.name === 'isRememberMe') && (e.target.checked === false)) {
      localStorage.removeItem('username');
      localStorage.removeItem('userPassword');
    }
  };

  handleSubmit = (e, formData, inputs) => {
    e.preventDefault();
    this.login(formData);
  };

  handleErrorSubmit = (e,formData, errorInputs) => {
    //console.log(e,formData, errorInputs)
  };

  resetForm = () => {
    let formRef = this.formRef.current;
    formRef.resetValidationState(this.state.clearInputOnReset);
  };

  async login(postData){
    let path = apiPath.adminLogin;

    if(!_.isEmpty(postData)) {
      this.setState({loading: true});
      let options = {
        method: 'POST',
        headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
        body: JSON.stringify(postData)
      }
      let result = await Http(path, options);
    
      this.setState({loading: false});
      if(result.ok) {
        if(result.status === 200) {
          let resultData = await result.json();

          if(resultData.success === 2) {
            window.location = "/send-otp"
          }else if(resultData.success == true){
            let adminData = resultData.result;
            adminData.token = resultData.result.token;
            adminData.account_type = resultData.result.roles;
            if(this.state.isRememberMe){
              localStorage.setItem('username', this.state.username);
              localStorage.setItem('userPassword', this.state.password);
            }
            this.props.adminLogin(adminData);
          } else {
            this.setState({submitFormError: resultData.msg});
            setTimeout(() => {
              this.setState({submitFormError: null});
            }, 5000);
          }
        }
      } else {
        this.setState({submitFormError: result.statusText});
        setTimeout(() => {
          this.setState({submitFormError: null});
        }, 5000);
      }
    } else {
      console.log('No Response');
    }
  }

  response(){
    if(this.state.submitFormError) {
      return <Alert color="danger">
        {this.state.submitFormError}
      </Alert>
    }
  }

  showLoading(){
    if(this.state.loading) {
      return <i className="fa fa-spinner fa-spin"></i>
    }
  }

  myFunction() {
      var x = document.getElementById("password");

      if (x.type === "password") {
        x.type = "text";
        $("#icon_eyes").attr('class', 'fa fa-eye-slash');
      } else {
        x.type = "password";
        $("#icon_eyes").attr('class', 'fa fa-eye');
      }
  }


  render() {

    if(!_.isEmpty(this.props.admin)) {
      return <Redirect to='/dashboard' />
    }
    return (
      /*<div className="app flex-row align-items-center login-body" style={{backgroundImage:"url('../assets/img/backgeound-bg.jpg')"}}>*/
      <div className="app flex-row align-items-center login-body" style={{backgroundColor: "#5F5E66"}}>
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              <CardGroup>
                <Card className="login-card">
                  {this.response()}
                  <CardBody className="p-0">
                    <ValidationForm onSubmit={this.handleSubmit} onErrorSubmit={this.handleErrorSubmit}
                                    ref={this.formRef}
                                    immediate={this.state.immediate}
                                    setFocusOnError={this.state.setFocusOnError}
                                    defaultErrorMessage={{ required: "Please enter something."}} >
                      <div className="logoouteradmin"><img src={logo} alt="BuyBee Logo"/></div>
                      <div className="loginbox p-4 ">
                      <div className="text-center mb-4">
                        <h1 className="main-title">Welcome to Gamony</h1>
                      </div>
                        
                        <TextInput type={"hidden"} name="account_type" id="account_type" value={this.state.account_type} onChange={this.handleChange} placeholder={"Username"} required errorMessage="Please enter account type"/>
                        <InputGroup className="mb-3">
                          <TextInput name="username" id="username" value={this.state.username} onChange={this.handleChange} placeholder={"Username"} required errorMessage="Please enter username"/>
                        </InputGroup>
                        <InputGroup className="mb-4">
                          <InputGroupAddon addonType="prepend">
                          </InputGroupAddon>
                          <TextInput type={this.state.showPassword ? "text" : "password"} name="password" value={this.state.password} onChange={this.handleChange} id="password" placeholder={"Password"} required errorMessage="Please enter password"/>
                           <div className="eyeicon"><i id="icon_eyes" className="fa fa-eye" onClick={this.myFunction}></i></div>
                        </InputGroup>
                        <Row>
                          <Col xs="6">
                            <FormGroup check>
                              <Label check>
                                <Input type="checkbox" name="isRememberMe" id="isRememberMe"
                                  checked={this.state.isRememberMe}
                                  onChange={this.handleChange}
                                />{' '}
                                  Remember Me
                              </Label>
                            </FormGroup><br />
                          </Col>
                          <Col xs="6" className="text-right">
                            <Link to="/forgot-password">Forgot password?</Link>
                          </Col>
                        </Row>
                        <Row className="align-items-center">
                          <Col xs="12" className="text-center">
                            <Button color="primary" type={"submit"} className="px-4">Login {this.showLoading()}</Button>
                          </Col>
                        </Row>
                      </div>
                    </ValidationForm>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Login);
